/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewRankingItem } from './CRSFSecReviewRankingItem';
import {
    CRSFSecReviewRankingItemFromJSON,
    CRSFSecReviewRankingItemFromJSONTyped,
    CRSFSecReviewRankingItemToJSON,
} from './CRSFSecReviewRankingItem';

/**
 * 
 * @export
 * @interface CRSFSecReviewPopularityRankingResult
 */
export interface CRSFSecReviewPopularityRankingResult {
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewPopularityRankingResult
     */
    domain: string;
    /**
     * 
     * @type {Array<CRSFSecReviewRankingItem>}
     * @memberof CRSFSecReviewPopularityRankingResult
     */
    rankings: Array<CRSFSecReviewRankingItem>;
}

/**
 * Check if a given object implements the CRSFSecReviewPopularityRankingResult interface.
 */
export function instanceOfCRSFSecReviewPopularityRankingResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "domain" in value;
    isInstance = isInstance && "rankings" in value;

    return isInstance;
}

export function CRSFSecReviewPopularityRankingResultFromJSON(json: any): CRSFSecReviewPopularityRankingResult {
    return CRSFSecReviewPopularityRankingResultFromJSONTyped(json, false);
}

export function CRSFSecReviewPopularityRankingResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewPopularityRankingResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'domain': json['domain'],
        'rankings': ((json['rankings'] as Array<any>).map(CRSFSecReviewRankingItemFromJSON)),
    };
}

export function CRSFSecReviewPopularityRankingResultToJSON(value?: CRSFSecReviewPopularityRankingResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'domain': value.domain,
        'rankings': ((value.rankings as Array<any>).map(CRSFSecReviewRankingItemToJSON)),
    };
}

